/**
 * Returns true when the app is running as an installed PWA
 * (standalone display mode, or iOS Safari's `navigator.standalone`).
 */
export const isRunningAsPWA = (): boolean => {
  if (typeof window === "undefined") return false;
  const standaloneMedia =
    window.matchMedia?.("(display-mode: standalone)").matches ?? false;
  const iosStandalone =
    (window.navigator as unknown as { standalone?: boolean }).standalone ===
    true;
  return standaloneMedia || iosStandalone;
};
